import React, { useContext, useEffect, useState } from 'react';
import {
    MDBBtn,
    MDBInput,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle
} from 'mdb-react-ui-kit';
import '../../stylesheet/bs-stepper.css'
import './SideNav.css';
import { AppContext } from '../App';
import UserControlService from '../../services/user-control-service';
import { Project } from 'konect-model';
import ProjectService from '../../services/project-service';
import ShareMenu from './ShareMenu';

export enum NavEvent {
    TOGGLE_STATIC_SIDENAV = "TOGGLE_STATIC_SIDENAV",
    TOGGLE_IDEABOX = "TOGGLE_IDEABOX",
    TOGGLE_TABLE_GLYPHSKETCHING = "TOGGLE_TABLE_GLYPHSKETCHING"
}

interface ProjectSettingsProps {
    showProjectSettings: boolean;
    setShowProjectSettings: (state: boolean) => void;
    onLoad: () => void;
}

export default function ProjectSettings(props: ProjectSettingsProps) {
    const { project } = useContext(AppContext);

    // project edit dialog states 
    const [editProject, setEditProject] = useState<Project>();
    const [projectNameInput, setProjectNameInput] = useState("");
    const [confirmDelete, setConfirmDelete] = useState(false);

    // share menu states
    const [shareMenuUsers, setShareMenuUsers] = useState([...(Array.isArray(project.users) ? project.users : [])]);
    const [shareMenuSearchResults, setShareMenuSearchResults] = useState<string[]>([]);
    const [shareMenuSearchInput, setShareMenuSearchInput] = useState("");


    // edit project functions
    async function deleteProject() {
        if (!editProject) return;
        if (!confirmDelete) {
            setConfirmDelete(true);
        } else {
            await ProjectService.deleteProject(editProject);
            props.setShowProjectSettings(false);
            props.onLoad();
        }
    }

    const saveEditDialog = () => {
        if (editProject) {
            editProject.name = projectNameInput;
            project.users = shareMenuUsers;
            UserControlService.save();
        } else {
            UserControlService.showInfoPopup({ title: "Client Error", content: `Project could not be edited.`, duration: 5000, color: "danger" });
        }
        props.setShowProjectSettings(false);
    }

    const cancelEditDialog = () => {
        props.setShowProjectSettings(false);
    }

    useEffect(() => {
        setShareMenuUsers([...(Array.isArray(project.users) ? project.users : [])].sort((a, b) => b.role - a.role));
        setShareMenuSearchInput("");
        setEditProject(project);
        setProjectNameInput(project?.name ?? "");
        setConfirmDelete(false);
    }, [props.showProjectSettings])

    useEffect(() => {
        const handleEscape = (event:any) => {
            if (event.key === "Escape" && props.showProjectSettings) cancelEditDialog();
        };
        const handleEnter = (event:any) => {
            if (event.key === "Enter" && props.showProjectSettings) {
                const activeElement = document.activeElement;
                if (activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA")) return;
                event.preventDefault();
                saveEditDialog();
            }
        };
    
        document.addEventListener("keydown", handleEscape);
        document.addEventListener("keydown", handleEnter);
        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.removeEventListener("keydown", handleEnter);
        };
    }, [editProject, project]);

    return (
        <MDBModal staticBackdrop show={props.showProjectSettings}>
            <MDBModalDialog style={{ marginTop: "20vh" }}>
                <MDBModalContent>
                    <MDBModalHeader>
                        <MDBModalTitle>Project Settings</MDBModalTitle>
                        <MDBBtn className='btn-close' color='none' onClick={cancelEditDialog}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody style={{ maxHeight: "50vh", overflowY: "auto" }}>
                        <div className="d-flex flex-column gap-2">
                            <h2>Change Name</h2>
                            <MDBInput id='projectname-input' label="Project Name" wrapperClass="w-full" type="text" value={projectNameInput} onChange={(e: any) => setProjectNameInput(e.target.value)} />
                        </div>
                        <hr />
                        <div className="d-flex flex-column">
                            <h2>Assign Users</h2>
                            <ShareMenu 
                                shareMenuUsers={shareMenuUsers}
                                setShareMenuUsers ={setShareMenuUsers}
                                shareMenuSearchResults={shareMenuSearchResults}
                                setShareMenuSearchResults={setShareMenuSearchResults}
                                shareMenuSearchInput={shareMenuSearchInput}
                                setShareMenuSearchInput={setShareMenuSearchInput}
                            />
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <div className="d-flex justify-content-between w-100">
                            <MDBBtn color='danger' outline={confirmDelete} style={{width: "150px"}} onClick={() => deleteProject()}>{confirmDelete ? "Are you sure?" : "Delete Project"}</MDBBtn>
                            <div className="d-flex gap-2">
                                <MDBBtn type='submit' onClick={saveEditDialog}>Save</MDBBtn>
                                <MDBBtn onClick={cancelEditDialog}>Cancel</MDBBtn>
                            </div>
                        </div>
                    </MDBModalFooter>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    );
}